// extracted by mini-css-extract-plugin
module.exports = {"bar":"_5D3Kp8gl","tabs":"_5DP3_2Zi","tab":"_5D1oL8xG","tab__expanded":"_5D36qOiE","tab__not-expanded":"_5D7WwHnB","header":"_5DmyEoeA"};